import { Component, Input } from '@angular/core';
import { IPatientRequestDetail } from '@app/core/patient-requests';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'afoone-patient-request-header',
  templateUrl: './patient-request-header.component.html',
  styleUrls: ['./patient-request-header.component.css'],
})
export class PatientRequestHeaderComponent {
  @Input() request: IPatientRequestDetail;

  get logoUrl(): string {
    const logoFromEnv = environment.clientLogoUrl;
    return logoFromEnv || 'assets/img/logo.svg';
  }
}
